import React, {useState} from "react";
import {Button, DescriptionListItem, DescriptionListItemActions} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import ChangePasswordModal from "./ChangePasswordModal";
import DescriptionListCard from "../../../descriptionList/DescriptionListCard";

const SecuritySettingsTab = () => {
    const intl = useIntl();
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

    return (
        <>
            <DescriptionListCard
                title={intl.formatMessage({id: "security"})}
                description={intl.formatMessage({id: "securitySettingsAccount"})}
            >
                <DescriptionListItem
                    title={intl.formatMessage({id: "password"})}
                    content={"•••••••••••••••"}
                    actions={
                        <DescriptionListItemActions>
                            <Button
                                variant={"link"}
                                buttonAction={{
                                    as: "button",
                                    actionProps: {
                                        onClick: () => setShowChangePasswordModal(true)
                                    }
                                }}
                            >
                                <FormattedMessage id={"change"}/>
                            </Button>
                        </DescriptionListItemActions>
                    }
                />
            </DescriptionListCard>

            <ChangePasswordModal
                show={showChangePasswordModal}
                onClose={() => setShowChangePasswordModal(false)}
            />
        </>
    );
};

export default SecuritySettingsTab;